import React from "react";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { LinearProgress } from "@material-ui/core";
import "./loading.scss";

const theme = createTheme({
  overrides: {
    MuiLinearProgress: {
      colorPrimary: {
        backgroundColor: "#078A34",
      },
      barColorPrimary: {
        backgroundColor: "darkgreen",
      },
    },
  },
});

export default () => {
  return (
    <section className="container h-100 flex w-100 flex flex-col justify-center">
      <ThemeProvider theme={theme}>
        <div className="flex flex-col justify-center w-100 h-100 mt-30">
          <div className="h-100 w-100 flex flex-row justify-center mb-5">
            <span>Carregando ...</span>
          </div>
          <LinearProgress className="w-100 h-100" />
        </div>
      </ThemeProvider>
    </section>
  );
};
